import ApplicationController from '../application_controller.js'

/*
 * Transfer to Cfile
 */

export default class TransferToCfileController extends ApplicationController {

  select_deselect(e) {
    e.target.closest("form").querySelectorAll(".record_selector").forEach(checkbox => {
      checkbox.checked = e.target.checked
    })
    this.enableSubmit()
  }

  clickCheck(e) {
    this.enableSubmit()
  }

  enableSubmit() {
    var can = false

    this.element.closest("form").querySelectorAll(".record_selector").forEach(e => {
      if (e.checked) {
        can = true
      }
    })
    this.element.closest("form").querySelector("input[type=submit]").disabled = !can
  }

}